import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetDealerBySapDropdownListQuery } from '../../api/endpoints/dealer';
import { useLanguage } from '../../contexts/LanguageContext';

const DealerDropdownBySap = ({ value, onChange, className = '', disabled = false, placeholder = 'Bayi seçiniz veya arayınız', rowCount = 10, initialSearchText = '' }) => {
    const { th } = useLanguage();
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [searchText, setSearchText] = useState(initialSearchText);

    const { data: dealerList = [], isLoading: isLoadingDealers } = useGetDealerBySapDropdownListQuery({
        RowCount: 9999,
        SearchText: searchText
    });

    const dealerOptions = dealerList.map((dealer) => {
        const countryCode = dealer.countryCode || dealer.CountryCode || null;
        const countryName = dealer.countryName || dealer.CountryName || null;

        return {
            sapDealerId: dealer.sapDealerId,
            erpDealerNumber: dealer.erpDealerNumber,
            name: dealer.name,
            text: dealer.translatedText || dealer.name,
            branchStatus: dealer.branchStatus,
            countryCode,
            countryName,
            sortName: dealer.sortName,
            displayValue: `${dealer.name} (${th('customer.status')}= ${dealer.branchStatus} | ${th('customer.dealerCode')}= ${dealer.erpDealerNumber})`
        };
    });

    const handleSelectionChange = (e) => {
        setSelectedDealer(e.value);
        onChange(e.value || {});
    };

    const handleFilterChange = (e) => {
        setSearchText(e.filter);
    };

    useEffect(() => {
        if (value && dealerOptions.length > 0) {
            let found = null;

            if (typeof value === 'object' && value !== null) {
                found = dealerOptions.find((option) => option.sapDealerId?.toString() === value.sapDealerId?.toString() || option.erpDealerNumber?.toString() === value.erpDealerNumber?.toString());
            } else {
                found = dealerOptions.find((option) => option.sapDealerId?.toString() === value?.toString() || option.erpDealerNumber?.toString() === value?.toString());
            }

            if (found && (!selectedDealer || selectedDealer.sapDealerId?.toString() !== found.sapDealerId?.toString())) {
                setSelectedDealer(found);
            }
        } else if (!value && selectedDealer) {
            setSelectedDealer(null);
        }
    }, [value, dealerOptions]);

    return (
        <Dropdown
            dataKey="sapDealerId"
            value={selectedDealer}
            options={dealerOptions}
            onChange={handleSelectionChange}
            onFilter={handleFilterChange}
            optionLabel="displayValue"
            filter
            showClear
            filterBy="erpDealerNumber,name,text"
            className={className}
            placeholder={placeholder}
            loading={isLoadingDealers}
            disabled={disabled}
            virtualScrollerOptions={{ itemSize: 42 }}
            dropdownStyle={{ minWidth: '100%' }}
            scrollHeight="300px"
            appendTo="self"
            itemTemplate={(option) => <div>{option.displayValue}</div>}
        />
    );
};

export default DealerDropdownBySap;
